// ALUMNI CARD/MODAL MARKUP
// [[src/assets/js/pages/alumni.js]]
import { html } from "../base/_utils";

export const alumni = [
  /* ******************** LEADERS OF THE PACK ******************** */
  // Dustin Bonn
  {
    id: "dustinBonn",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/dustin-bonn.webp",
    name: "Dustin Bonn, 2011",
    title: "Vice President of IT Operations at Marco Technologies | Sioux Falls, SD",
    bio: html`
      <p>
        Dustin serves as Vice President of IT Operations at Marco Technologies in Sioux Falls, South
        Dakota. In his leadership role, he focuses on building strong teams, developing people, and
        creating systems that support meaningful, long-term success. His career reflects a steady
        commitment to growth, collaboration, and impact. A proud NSU Wrestling alumnus, Dustin
        credits the program with shaping much of his leadership mindset. The discipline,
        accountability, and resilience developed on the mat continue to influence how he leads in
        the boardroom today. He remains closely connected to the program as a supporter and as a
        member of the Wrestling Program Advisory Council. Beyond his profession, Dustin is deeply
        invested in his community. He has volunteered with Junior Achievement, coached with Dakota
        Alliance Soccer Club, served as Vice President of the Dakota Alliance Soccer Club Board of
        Directors, and contributed to the Sioux Falls Young Professional Network. He is also a
        graduate of Leadership Sioux Falls, Class of 35—continuing his commitment to civic
        engagement and local leadership. But when asked about his greatest achievement, Dustin
        brings it back to what matters most: “Building a life grounded in family, values, and
        meaningful work. I've been fortunate to grow into roles where I can help people develop,
        support teams, and contribute in a way that matters. Being a husband and father keeps
        everything in perspective.” Dustin and his wife, Jenna, are raising two sons—Dane (13) and
        Archer (2)—in Sioux Falls. For him, leadership starts at home and extends outward.
        Reflecting on his time at Northern, Dustin shares: “NSU played a big role in shaping who I
        am. Wrestling reinforced discipline and accountability. Just as important, many of my
        closest friendships today started at Northern. The relationships and sense of community at
        NSU have stayed with me and continue to influence how I think about leadership, work, and
        staying connected.” His advice to current and future Wolves? “Get involved and take
        ownership of your experience. Build relationships, challenge yourself, and stay connected.
        What you take from Northern will grow over time if you continue to invest in it after
        graduation.”
      </p>
    `,
  },
  // Carlos
  {
    id: "carlosCamancho",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/carlos-camancho.webp",
    name: "Carlos Camancho, 2010",
    title: "Consumer Loan Officer at Area Federal Credit Union | Aberdeen, SD",
    bio: html`
      <p>
        Carlos serves as a Consumer Loan Officer at Area Federal Credit Union, where he partners
        with members to build financial plans that create lasting stability and opportunity. For
        Carlos, success is measured not just in numbers—but in the milestones his clients achieve
        along the way. When asked about his greatest professional accomplishment, he shares: “One of
        my greatest accomplishments has been witnessing the successful outcomes of our members and
        clients who diligently follow the financial plans we collaborate on. Seeing these plans
        materialize is truly rewarding.” On a personal level, however, his proudest achievements are
        even deeper: “Getting to know God and becoming a father are the greatest.” Carlos and his
        fiancée, Natalie, are raising Mason and Isabel in Aberdeen—grounding their life in faith,
        family, and community. Beyond his professional role, Carlos is actively engaged in service
        throughout Aberdeen. He serves as Treasurer on the Executive Board of the Aberdeen
        Convention & Visitors Bureau, is a board member for the K.O. Lee Aberdeen Public Library
        Foundation, and chairs the NSU Alumni Association Committee—continuing to invest in the
        university that helped shape him. Reflecting on his time at Northern, Carlos says: “My time
        at NSU is crucial to my life and career. The constant development of the university reminds
        me that personal growth can have resting or reset moments, but the journey should never
        stop. Achievements come in all sizes and time frames—I work to value them all.” His advice
        to current and future Wolves? “Northern offers all the tools you need to get out of your
        comfort zone, test yourself, and turn ideas into action. Take advantage of every opportunity
        and give your all so you don't have any regrets. Go Wolves!”
      </p>
      <p></p>
    `,
  },
  // Katie (Wegleitner) Cramer
  {
    id: "katieCramer",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/katie-cramer.webp",
    name: "Katie (Wegleitner) Cramer, 2016",
    title: "Sergeant in the South Dakota Army National Guard | Holmen, WI",
    bio: html`
      <p>
        Katie (Wegleitner) Cramer - 2016 A Sergeant in the South Dakota Army National Guard with 15
        years of service, Katie has built a life defined by discipline, compassion, and an
        unwavering commitment to others. Alongside her military service, she is a Doctor of Nursing
        Practice Candidate and Nurse Anesthesia Student through the Mayo Clinic School of Anesthesia
        and Viterbo University, with graduation set for May 2026. Her path reflects both academic
        excellence and servant leadership. A Cum Laude graduate of NSU, former Fine Arts Senator,
        nursing class president, and member of Sigma Theta Tau Honor Society, Katie recently
        completed her M.S. in Biology and continues advancing toward the highest level of clinical
        nursing practice. Her military honors include the Military Outstanding Volunteer Service
        Medal, Distinguished Service Awards (x3), Soldier of the Quarter, the Army Reserve
        Components Achievement Medal, and being coined by the Command Sgt. Major of the SD Army
        National Guard for exceptional contributions to medical readiness and Soldier care during
        Annual Training and overseas operations in Suriname, South America. But her impact reaches
        far beyond uniform. Katie founded Hearts in the Park, mobilizing community partners and
        raising thousands of dollars to support individuals experiencing homelessness in La Crosse,
        WI. Her work earned her a Jefferson Award, and in 2022 she represented Wisconsin at the 50th
        Annual Jefferson Awards ceremony, where she continued serving by packaging nearly 3,000
        meals during a national shortage crisis. When asked about her greatest achievement, Katie
        shared: “My greatest achievement will be earning my Doctor of Nursing Practice while
        continuing to serve in the Army National Guard. Being accepted into a highly competitive
        nurse anesthesia program through Mayo Clinic was both an honor and a challenge. Navigating
        these responsibilities simultaneously required sacrifice and careful balance, but it
        reinforced my commitment to service, lifelong learning, and showing up fully in every
        chapter of my life.” Katie credits NSU for shaping her mindset early on. “During my very
        first year, a theatre professor shared a simple statement that has stayed with me ever
        since: ‘Every day is an interview.' I took that to heart early on. It encouraged me to stay
        curious, prepared, and open to learning.” She also met her husband, Calvin—2016 NSU alum—on
        campus, sharing a piano bench in Dr. Faflak's studio before he later proposed at NSU. Her
        advice to current Wolves? “Live your life to the fullest. Say yes to every opportunity…
        Throw yourself into the experience and leave it all out on the table. These years move
        quickly, and each day is a gift.” From Lake City, SD, to Holmen, WI, Katie exemplifies what
        it means to lead with courage, humility, and heart.
      </p>
    `,
  },
  // Brady Harr
  {
    id: "bradyHarr",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/brady-harr.webp",
    name: "Brady Harr, 2016",
    title: "Physical Therapist, VA Black Hills Health Care System| Spearfish, SD",
    bio: html`
      <p>
        Brady serves as a Physical Therapist with the VA Black Hills Health Care System and resides
        in Spearfish, South Dakota. Through his work, he is dedicated to helping veterans restore
        function, achieve their goals, and improve their quality of life—building meaningful
        connections with patients every day. His greatest professional milestone was completing his
        Doctor of Physical Therapy degree at Briar Cliff University—an achievement that launched a
        career centered on service and impact. Brady's commitment to excellence has earned him the
        SD APTA Genesis Award (2024), the VA Heartfelt Award (2023), and the VA BRAVO Award (2025).
        He is an active member of the American Physical Therapy Association at both the national and
        state levels and was published in The Permanente Journal in 2018. Beyond his clinical work,
        Brady is deeply engaged in leadership and service. He serves as Co-Chair of the Education
        Committee for the South Dakota APTA, Board President for Black Hills State University
        Lutheran Campus Ministry, a member of Our Savior's Lutheran Church Council and Call
        Committee, and previously chaired the Outreach Committee for the Briar Cliff University DPT
        Alumni Board. He also volunteers as a one-on-one coach for local Track & Field athletes.
        Brady credits his time as a member of the NSU Track & Field team with shaping his
        perseverance and resilience. “My time at NSU was truly life changing. Being part of the
        Track & Field team taught me how to persevere and push myself past my physical and mental
        boundaries. My professors and mentors challenged me and prepared me for my graduate degrees.
        The best part of all was finding an amazing group of friends and teammates—and my future
        wife—during my time at NSU.” Brady and his wife, Molly (2017 NSU grad), are proud parents to
        Hudson and Sadie. His advice to current Wolves? “Find your network. Find the people that
        will be by your side, but not afraid to challenge you at the same time. Most of all, enjoy
        your time—it will be over before you know it.”
      </p>
    `,
  },
  // Brianna Husler
  {
    id: "briannakusler",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/brianna-kusler.webp",
    name: "Brianna (Kusler) Kaiser, 2020",
    title: "Owner of Larkspur Landing Event Center | Pierre, SD",
    bio: html`
      <p>
        Brianna is a business owner, educator, and community leader in Pierre, South Dakota. She
        owns Larkspur Landing Event Center—named 2025 CSD Event Center of the Year—and Kusler
        Klinics. She also serves as a Preschool Teacher at Chalk Preschool and KKVC Club Director,
        investing daily in the growth and development of young people. A former student-athlete,
        Brianna credits athletics with instilling the discipline, teamwork, and perseverance that
        continue to guide her leadership today. Her impact has been recognized across multiple
        arenas, including being named 2023 Region 3 Head Boys Basketball Coach of the Year for the
        Pierre Governors and a 2025 CSD Mover & Shaker nominee. She has also served as a BIG Idea
        Business Panelist and held leadership roles on both the SDHSBCA Region Board and PACA Board.
        Beyond her professional accomplishments, Brianna is deeply committed to community service.
        She serves on the Executive Board for the Central South Dakota Recreation Committee,
        supports entrepreneurship as a board member of Central South Dakota WE, and coordinates the
        KKVC Building Better Initiative—leading youth scholarships, food drives, volunteer efforts,
        and holiday donation programs. When asked about her greatest achievement, Brianna shares:
        “My greatest achievement has been building a life and career centered on leadership,
        service, and community connection. Whether through entrepreneurship, leadership roles, or
        community involvement, I am proud to create opportunities that bring people together and
        make a meaningful impact.” Reflecting on her time at Northern, she credits NSU for shaping
        both her professional path and personal values: “NSU provided a strong foundation in
        leadership, communication, and relationship-building while encouraging involvement beyond
        the classroom. The connections I gained during my time as a Wolf continue to influence how I
        approach leadership, challenges, and service today.” Her advice to current Wolves? “Take
        full advantage of the opportunities NSU offers—get involved early, say yes to opportunities
        that push you outside your comfort zone, and build relationships. The connections and
        experiences you create will last far beyond graduation.” Brianna and her husband, Brevin,
        continue to invest in the Pierre community they call home—bringing people together and
        leading with purpose.
      </p>
    `,
  },
  // Lee Kessler
  {
    id: "leeKessler",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/lee-kessler.webp",
    name: "Lee Kessler, 2009",
    title: "Owner and Partner of RhodesAnderson Insurance | Aberdeen, SD",
    bio: html`
      <p>
        Lee is Owner and Partner of RhodesAnderson Insurance in Aberdeen, South Dakota, where he has
        built a thriving business culture centered on growth, service, and leadership. He and his
        wife, Sarah, are proud parents to Lydia, Kaydee, and Dawson. One of Lee's proudest
        achievements is instilling a passion for growth in the people around him—spiritually with
        his family, professionally with his colleagues, and civically through his community
        involvement. He currently serves on the YMCA board and the finance committee at Aldersgate
        Church and previously contributed as a board member for the Aberdeen Downtown
        Association/BID District. Lee credits his time at Northern State University with teaching
        him how to embrace challenges, persevere through obstacles, and work collaboratively toward
        solutions. “My experiences at NSU taught me how to embrace challenges and to know how it
        feels to work through obstacles toward a solution. Balancing collegiate athletics and
        academics helped me develop a work ethic I can rely on when things get tough.” His advice to
        current Wolves? “Don't feel like you have to have it all figured out. Take on the day with a
        positive attitude, focus on what you can control, and develop a consistent work ethic.”
      </p>
    `,
  },
  // Wade Royer
  {
    id: "wadeRoyer",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/wade-royer.webp",
    name: "Wade Royer, 2010",
    title: "Construction Estimator at Haar Plumbing, Owner of Grassroots Lawn Care | Aberdeen, SD",
    bio: html`
      <p>
        Wade is a Construction Estimator at Haar Plumbing and the owner of Grassroots Lawn Care in
        Aberdeen, South Dakota. He and his wife, Kayley, are proud parents to Kenley (13), Kollins
        (7), and Bennett (3 months). A former NSU track and field standout, Wade was a 3-time
        All-Conference athlete, 7-time National Qualifier in pole vault, the first NSU pole vaulter
        over 16 feet, and a former school record holder. That passion for pole vault has carried
        into his coaching, where he has served 12 years as NSU's Pole Vault Coach—10 of those years
        as a volunteer. Under his guidance, the vault program has produced 5 All-Americans, 9
        conference champions, 31 all-conference selections, and 79 conference placers, consistently
        ranking in the top 10 nationally for Division II pole vault programs. In 2021, the women's
        vault team was ranked the 3rd best vault team in the nation. Wade also hosts clinics and
        camps for middle and high school athletes across South Dakota, North Dakota, and Minnesota,
        giving young athletes opportunities to grow and compete. When asked about his greatest
        achievement, Wade shares: “Outside of marrying my wife, my greatest achievement is what I've
        been able to build with the NSU Pole Vault program. Our athletes consistently compete
        nationally, break school records, and have even competed in world-renowned events such as
        the Commonwealth Games and the British Championships.” Reflecting on his time at NSU, Wade
        says: “NSU gave me a new home. While being a student-athlete, I was supported by the
        community and staff throughout my time. Having that constant support helps make the
        transition to college easier when everything is new and you're trying to do everything on
        your own.” His advice to current and future Wolves: “Ask questions and believe in yourself.
        Work hard, learn from others, and remember that you're never alone when you're willing to
        learn.”
      </p>
    `,
  },
  // Lorisa (Schoenbeck) Rudolph
  {
    id: "lorisaRudolph",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/lauren-rudolph.webp",
    name: "Lorisa (Schoenbeck) Rudolph , 2019",
    title: "Chief Financial Officer of Northern Electric Cooperative | Aberdeen, SD",
    bio: html`
      <p>
        Lorisa serves as Chief Financial Officer of Northern Electric Cooperative in Aberdeen, SD.
        In her role, she leads with precision, integrity, and a commitment to financial stewardship
        that supports communities across the region. One of her proudest accomplishments was earning
        her CPA designation—an achievement that required more than 1,000 hours of dedicated study
        and unwavering determination. That milestone reflects the discipline and perseverance that
        continue to define her leadership today. Beyond her professional role, Lorisa is deeply
        invested in her community. She serves as a board member for Aberdeen Development Corp and is
        an active member of the South Dakota CPA Society and the National Society of Accountants for
        Cooperatives. She is also a lifetime member of Girl Scouts, carrying forward a long-standing
        commitment to leadership and service. At home, Lorisa and her husband, JC (2019 NSU grad),
        are raising two young children, Leo (3) and Everly (1). For Lorisa, success is grounded in
        balancing meaningful work with a strong, family-centered life. Reflecting on her time at
        Northern, Lorisa emphasizes the value of exploration and connection. She encourages students
        to lean into every opportunity: “Try every opportunity that might interest you. College is
        the best time in your life to explore different paths—both career and extracurricular—before
        you truly decide where your niche is. There truly is no better environment to do that at
        than Northern. I would also suggest getting to know people and creating meaningful
        relationships with peers and professors alike. Some of them may become lifelong friends.”
      </p>
    `,
  },
  // Kelsey Stock
  {
    id: "kelseyStock",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/kelsey-stock.webp",
    name: "Kelsey (Luckhurst) Stock, 2015",
    title: "Associate Attorney at Fluegel Anderson McLaughlin & Brutlag Chartered | Ortonville, SD",
    bio: html`
      <p>
        Kelsey serves as an Associate Attorney at Fluegel Anderson McLaughlin & Brutlag Chartered
        (d/b/a Fluegel Anderson) in Ortonville, Minnesota. A magna cum laude graduate of the
        University of North Dakota School of Law and elected to the Order of the Barristers, Kelsey
        brings excellence, integrity, and dedication to her legal practice. Beyond her profession,
        she is deeply committed to strengthening her community. Kelsey serves as a Board Member of
        the Big Stone Health Care Foundation, contributes to its Gala Committee, and volunteers with
        its golf tournament fundraiser. She is also a member of the Big Stone County Childcare
        Committee, chairing the fundraising subcommittee as local leaders work together to address
        regional childcare shortages. In addition, she provides pro bono legal services to local
        community organizations—ensuring meaningful access to support and advocacy. When asked about
        her greatest achievement, Kelsey reflects not on accolades, but on relationships: “My
        greatest achievement is the community and friendships I've built in my life. I know that
        whatever challenges life brings, I have a supportive group of friends and colleagues who
        would be willing to lend a hand or listening ear.” She credits her time at Northern for
        laying the foundation for both her personal and professional growth: “My time at Northern
        set me up for success by teaching me to be a lifelong learner and to explore curiosities.
        This environment fostered lifelong friendships with individuals who pushed me to be the best
        version of myself.” Her advice to current and future Wolves? “Show up. Show up for yourself,
        for others, and your community. Most good things cannot be accomplished alone, so showing up
        is the first step to accomplish something great.” Kelsey and her husband, Bryn, continue to
        invest in the Ortonville community they proudly call home.
      </p>
    `,
  },
  // Taylor Zemlicka
  {
    id: "kristanMorris",
    section: "leadersOfThePack",
    image: "assets/media/pages/alumni/leaders-of-the-pack/2026/taylor-zemlicka.webp",
    name: "Taylor Zemlicka, 2016",
    title: " Financial Advisor with Northwestern Mutual | Watertown, SD",
    bio: html`
      <p>
        A Financial Advisor with Northwestern Mutual in Watertown, SD, Taylor has earned
        professional recognition for consistently helping new clients get started, guiding families
        through important financial milestones, and maintaining a high standard of care—no matter
        the market environment. His work is rooted in relationships, trust, and long-term impact.
        Beyond his career, Taylor is deeply invested in his community. He has volunteered coaching
        high school football, supported the local Boys & Girls Club, and regularly leads personal
        finance discussions with students at LATC and area high schools—sharing practical knowledge
        that empowers young adults to take ownership of their futures. But when asked what he's most
        proud of, Taylor didn't point to awards. “I have to sneak two in here. One, we've created
        the ability for my wife to now stay at home with our kids. The second is that I'm able to
        help my parents on our family dairy farm each morning. While they may not seem like regular
        achievements, they've proven to provide the most peace to our family.” Taylor and his wife,
        Ashley—2017 Northern graduate—are raising three young children: Tucker (5), Taige (3), and
        Tallie (10 months). For him, leadership starts at home. Northern State played a defining
        role in both his career and personal life. “Professionally, the relationships I built at
        Northern State led me into my primary career. Personally, I've been blessed to start a
        family with a woman I couldn't have met otherwise. What's been cultivated from that has been
        more than I could've asked for. I owe plenty of thanks to NSU.” He describes Aberdeen and
        NSU as a place where community and accountability meet—a setting that leaves a lasting
        imprint long after graduation.
      </p>
    `,
  },
  /* ******************** DISTINGUISHED ******************** */

  // Kelly Weaver
  {
    id: "kellyWeaver",
    section: "distinguished",
    image: "assets/media/pages/alumni/distinguished-alumni/2026/kelly-weaver.webp",
    name: "Kelly Weaver, 1987",
    title: "Distinguished Alumni Award 2026",
    bio: html`
      <p>
        For nearly three decades, <strong>Kelly Weaver</strong> has been helping entrepreneurs
        transform ideas into successful businesses, strengthening communities across northeastern
        South Dakota through economic development, education and mentorship. A 1987 graduate of
        Northern State University with a Bachelor of Science degree in business administration,
        emphasizing finance and management and an economics minor, Weaver has built a career
        dedicated to empowering others and creating opportunities for growth.
      </p>
      <p>
        As regional director of the Small Business Development Center (SBDC), Weaver serves a
        13-county region in northeastern South Dakota, providing guidance and expertise to
        entrepreneurs at every stage of the business lifecycle. Since joining the SBDC in 1998, she
        has worked with more than 3,000 individuals exploring business ownership, launching
        startups, purchasing existing businesses, expanding operations or planning for succession.
      </p>
      <p>
        Through one-on-one consulting, financial planning assistance and business development
        support, Weaver has helped facilitate over 300 startups, business purchases, and expansions
        that contributed more than $119 million in investment. In addition, she has participated in
        nearly 300 training sessions, most as the lead instructor, reaching more than 6,000 aspiring
        and established business owners.
      </p>
      <p>
        Weaver's passion for entrepreneurship extends beyond individual consulting. She plays a
        pivotal role in cultivating the next generation of business leaders through the BIG Idea
        Competition, a business idea competition for high school students. Since helping launch the
        program in 2007, she has served as its coordinator, guiding its growth from a regional
        competition with 101 entries from 10 schools to a nationally recognized event attracting
        hundreds of participants annually.
      </p>
      <p>
        The competition, hosted at Northern State University and supported by community volunteers
        and sponsors, encourages students to think creatively, identify opportunities and explore
        entrepreneurship as a viable career path. More than 6,000 students have participated in the
        program since its inception.
      </p>
      <p>
        For Weaver, BIG Idea is about more than developing business plans. It is about helping young
        people recognize that they can make a meaningful impact in their own communities.
      </p>
      <p>
        Too often, young people in rural communities grow up believing success means leaving for a
        larger city, Weaver said. Success can start right where you are, and BIG Idea challenges the
        participants to look at their own communities, recognize opportunities and imagine ways to
        make a difference.
      </p>
      <p>
        Her commitment to entrepreneurship and economic development is rooted in a career that began
        shortly after graduating from Northern. After earning her degree, Weaver joined the
        Northeast Council of Governments (NECOG), where she worked in regional planning and economic
        development. When NECOG became home to the Small Business Development Center in 1998, her
        focus shifted toward directly assisting entrepreneurs, a role she has embraced ever since.
      </p>
      <p>
        Throughout her career, Weaver continues to expand her professional expertise. She holds
        certifications as an Economic Development Finance Professional, Housing Development Finance
        Professional, QuickBooks Pro Advisor and Certified Facilitator. She also completed Profit
        Mastery University training, further strengthening her ability to help business owners
        navigate financial decision-making and growth strategies.
      </p>
      <p>
        Her leadership and service have been recognized with numerous honors, including the Aberdeen
        Area Chamber of Commerce's ABBY Award for Professional Service, ABBY Award for Customer
        Service and the Woman of Spirit Award. She serves on advisory boards throughout the area,
        including the Northern Innovation and Startup Center board, helping strengthen
        entrepreneurship education and business development opportunities throughout the region.
      </p>
      <p>
        A longtime advocate for workforce development, Weaver has been actively involved with the
        Aberdeen Area Chamber of Commerce since 1998. She has contributed articles to Chamber
        Progress for more than two decades and has served on the workforce and education committee,
        including time as committee chair.
      </p>
      <p>
        Beyond her professional accomplishments, Weaver is widely recognized for her extensive
        volunteer service and community involvement. She has been a member of Sacred Heart Catholic
        Church's choir and cantor ministry for more than 25 years and has dedicated countless hours
        to organizations that enrich life in South Dakota.
      </p>
      <p>
        Among those organizations is the Aberdeen Drift Busters Snowmobile Club, where she has been
        an active member since 1986. Over the years, she has served as secretary, vice president and
        president while volunteering for safety education programs, conventions, fundraising events
        and community activities. Her leadership within organized snowmobiling has expanded to the
        state level through the South Dakota Snowmobile Association, where she served as president
        from 2023 to 2025. She also continues to represent South Dakota nationally through the
        American Council of Snowmobile Associations.
      </p>
      <p>
        Her dedication to the sport has earned significant recognition, including South Dakota Woman
        Snowmobiler of the Year, Snowmobile Family of the Year and induction into the Iron Dog
        Brigade, an honorary society recognizing individuals with decades of leadership and service
        within organized snowmobiling.
      </p>
      <p>
        Despite an impressive list of accomplishments, Weaver remains focused on the people she
        serves. Whether helping a first-time entrepreneur write a business plan, guiding a family
        through the purchase of a business or encouraging students to pursue innovative ideas, she
        believes success is built through relationships, support and community.
      </p>
      <p>
        Throughout her career, she has emphasized the importance of collaboration and mentorship,
        often noting that no entrepreneur succeeds alone. Her work reflects a deep belief in the
        power of connected communities and the importance of helping others realize their potential.
      </p>
      <p>
        Weaver and her husband, Jim, live in Aberdeen. They enjoy spending time with daughter Lauren
        Bittner, son-in-law Nick and grandchildren, Lennon and Gavin.
      </p>
      <p>
        Weaver said she has enjoyed watching the growth and changes at Northern over the years. She
        especially enjoys the times she can engage with students on campus. She regularly makes
        presentations to business students in class about entrepreneurship and serves as a judge for
        the student business pitch competition each fall. She has hired and mentored dozens of
        Northern students through internships during her time with the Small Business Development
        Center.
      </p>
      <p>
        Her career has been defined by a commitment to helping others succeed, whether through
        supporting entrepreneurs, mentoring future business leaders or strengthening community
        organizations. Through her leadership, service and unwavering dedication to economic
        development, she has left a lasting mark on northeastern South Dakota and exemplifies the
        impact Northern State University graduates can have on their communities.
      </p>
    `,
  },
  // Daniel Gallagher
  {
    id: "danielGallagher",
    section: "distinguished",
    image: "assets/media/pages/alumni/distinguished-alumni/2026/dan-gallagher.webp",
    name: "Daniel Gallagher, 2018",
    title: "G.O.L.D. Award",
    bio: html`
      <p>
        <strong>Daniel Gallagher</strong> has quickly established himself as one of South Dakota's
        most respected young educators, earning recognition at the local, state and national levels
        for his commitment to students, educational excellence and servant leadership. A 2018
        graduate of Northern State University with bachelor's degrees in elementary education and
        history, Gallagher is currently a middle school science teacher and head boys basketball
        coach at Aberdeen Roncalli, his alma mater. He is also pursuing a Master of Education in
        Leadership and Administration at Northern and will assume new responsibilities as dean of
        middle school and activities director at Roncalli beginning next school year.
      </p>
      <p>
        Gallagher's path to education began with a desire to coach. Entering Northern in 2014, he
        envisioned a future as a history teacher and football coach, believing coaching would
        provide the greatest opportunity to impact young people. It was through his experiences in
        Northern's School of Education, however, that he discovered the profound influence teachers
        have on students' lives.
      </p>
      <p>
        "The faculty and staff of the School of Education completely transformed my way of
        thinking," Gallagher said during Northern's 2025 rededication of the H.P. Gerber Building.
        "Teaching and coaching really aren't that far off. Every day as a teacher or coach, I have
        the opportunity to impact lives for the better."
      </p>
      <p>
        That philosophy has become the foundation of Gallagher's career. Since returning to
        Roncalli, he has taught a variety of subjects, including math, social studies, English
        language arts and science, consistently stepping into roles where he is needed most. Known
        for his enthusiasm, high expectations and strong relationships with students, Gallagher
        creates engaging learning experiences through hands-on, project-based activities that
        encourage curiosity and critical thinking. His students have built catapults, designed
        models of the digestive system, made ice cream to study thermal energy transfer and
        constructed roller coasters to explore principles of physics.
      </p>
      <p>
        Gallagher's commitment to student success extends well beyond the classroom. As head boys
        basketball coach and assistant football coach, he emphasizes character, accountability and
        service. He established study tables for students needing academic support and regularly
        writes handwritten notes to encourage personal growth. His teams participate in numerous
        community service projects, including volunteering at youth camps and leagues, cleaning
        gymnasiums after games and spending time with residents at Mother Joseph Manor during the
        holiday season.
      </p>
      <p>
        His impact has not gone unnoticed. In 2023, Gallagher was named Aberdeen Roncalli Teacher of
        the Year. The following year, he received one of education's highest honors, the Milken
        Educator Award, often referred to as the "Oscars of Teaching." He was surprised with the
        award during a schoolwide assembly in February 2025, becoming one of approximately 40
        educators nationwide selected that year and one of more than 3,000 recipients throughout the
        award's nearly 40-year history.
      </p>
      <p>
        "Dan Gallagher is a living example of what excellence in teaching looks like," said South
        Dakota Secretary of Education Dr. Joseph Graves during the award presentation. "He has a
        reputation as a teacher who inspires students to put forth their best efforts in all they
        do. He sets the bar high, and his students rise to meet his expectations."
      </p>
      <p>
        Gallagher credits much of his success to the educators and mentors who invested in him
        throughout his life. Their guidance helped shape a philosophy that continues to drive his
        work today: empowering students to make a difference in the lives of others while striving
        to become the best versions of themselves.
      </p>
      <p>
        Schwan, now dean of Northern's Millicent Atkins School of Education, remembers Gallagher as
        one of her first students when she joined the university faculty.
      </p>
      <p>
        "He's not only an extremely successful teacher at Aberdeen Roncalli, but he's also dearly
        loved," Schwan said. "We could not be prouder. Our hearts nearly burst when he was named a
        highly esteemed Milken Educator."
      </p>
      <p>
        Beyond the classroom, Gallagher has emerged as a leader and advocate for education
        throughout the state. He served as a keynote speaker for Northern's rededication of the H.P.
        Gerber Building and the university's Learning Expo for students exploring careers in
        education. He has presented at the South Dakota High School Football Coaches Association
        Coaching Clinic and helped organize the South Dakota Milken Network, bringing together
        Milken Educators across the state to support current and future teachers.
      </p>
      <p>
        His contributions have earned additional recognition, including being named one of
        Aberdeen's Top 4 Under 40 honorees in 2026 and being featured on the cover of the Diocese of
        Sioux Falls' Bishop's Bulletin magazine.
      </p>
      <p>
        Despite the accolades, Gallagher remains focused on what matters most: helping students
        discover their potential. He often speaks about the importance of relationships, service and
        helping young people recognize their value and ability to make a difference.
      </p>
      <p>
        "We were empowered every day in every class, on every project and in every passing
        conversation," Gallagher said of his experience at Northern. "The staff here recognized the
        true importance of education, and that is to make sure every student understands that they
        matter and they have the opportunity to be successful in whatever it is that they choose to
        do."
      </p>
      <p>
        Through his dedication to students, commitment to educational excellence and passion for
        serving others, Gallagher exemplifies the impact Northern graduates can have on their
        communities. As he continues to take on new leadership roles, his influence will undoubtedly
        extend far beyond the classroom, inspiring the next generation of learners, leaders and
        educators.
      </p>
    `,
  },
  // Tracy and Jim Thares
  {
    id: "davidVolk",
    section: "distinguished",
    image: "assets/media/pages/alumni/distinguished-alumni/2026/david-volk.webp",
    name: "David Volk, 1969",
    title: "Distinguished Alumni Award 2026",
    bio: html`
      <p>
        <strong>David Volk</strong> has spent a lifetime serving his country, his state and his
        community through military service, public leadership, volunteerism and storytelling. A 1969
        graduate of Northern State University, Volk has built an extraordinary legacy that spans
        decades of service and achievement, making a lasting impact on South Dakota and beyond.
      </p>
      <p>
        Born and raised in Mitchell, South Dakota, Volk graduated from Northern and was immediately
        drafted into the U.S. Army. He served two years in the military, including a year in Vietnam
        as a combat photographer with the 101st Airborne Division. During his service, he documented
        the realities of war while serving alongside fellow soldiers in challenging and often
        dangerous conditions. For his dedication and service, Volk received the Army Commendation
        Medal and the Bronze Star.
      </p>
      <p>
        Following his military service, Volk returned home and embarked on a remarkable career in
        public service. In 1972, at just 25 years old, he ran for South Dakota State Treasurer and
        won, becoming the youngest person in state history elected to a statewide office at the
        time. Voters would return him to the position four more times, entrusting him with the
        responsibility for managing the state's finances for nearly two decades.
      </p>
      <p>
        During his tenure as state treasurer, Volk helped establish the National Association of
        State Treasurers and was elected its first president, demonstrating leadership that extended
        well beyond South Dakota's borders. His work helped strengthen collaboration among state
        financial officers across the nation and elevated South Dakota's role in shaping public
        finance policy.
      </p>
      <p>
        In 1994, Volk was appointed secretary of the South Dakota Department of Commerce and
        Regulation by Governor Bill Janklow. He served in that cabinet-level position until 2002,
        helping guide economic development, business regulation and financial oversight during a
        period of growth and change for the state.
      </p>
      <p>
        Throughout his career, Volk has remained deeply committed to serving others. He was
        appointed by the Reagan Administration as chairman of the Vietnam Veterans Volunteer Program
        for South Dakota, where he helped establish outreach efforts for veterans struggling with
        the challenges of returning home from war. His dedication to veterans continues through his
        involvement with organizations including the American Legion, Veterans of Foreign Wars and
        Disabled American Veterans, where he is a life member.
      </p>
      <p>
        Volk's commitment to community service is equally impressive. Through the Big Brothers Big
        Sisters program, he spent 13 years mentoring his “little brother,” Drake. He also served for
        two decades on the South Dakota Advisory Committee to the U.S. Equal Employment Opportunity
        Commission, as well as spending time as chairman of the South Dakota Human Rights Commission
        and a member of the South Dakota Funeral Board.
      </p>
      <p>
        In addition to his accomplishments in government and community service, Volk has built a
        successful career as an author. Drawing from his experiences in Vietnam, he wrote
        <em>Draftee: A High School Teacher Goes to War</em>, a memoir chronicling his military
        service. He also authored <em>My Grandpa's War</em>, a children's book designed to help
        younger generations understand the experiences of those who served during wartime.
      </p>
      <p>
        Working alongside Mark Meierhenry, Volk co-authored a series of children's books that
        combine education and adventure, including <em>Mystery of the Round Rocks</em>,
        <em>Mystery of the Tree Rings</em>, <em>Mystery of the Maize</em> and
        <em>Mystery of the Black Hills</em>. Two of the books earned national recognition, receiving
        Bronze and Silver Medals from the Independent Book Publishers Association. His most recent
        work, <em>Fearless Felix</em>, tells the story of a bomb-sniffing German shepherd and
        highlights the extraordinary contributions of service dogs throughout history.
      </p>
      <p>
        Whether serving his country overseas, leading at the highest levels of state government,
        mentoring young people, advocating for veterans or sharing stories through the written word,
        Volk has consistently demonstrated a commitment to improving the lives of others. His career
        reflects the values of leadership, service and lifelong learning that Northern State
        University seeks to instill in its graduates.
      </p>
      <p>
        More than five decades after leaving Northern's campus, Volk continues to make a difference
        in the lives of South Dakotans through his public service, volunteer efforts and educational
        work. His remarkable record of achievement and dedication stands as an example of how one
        individual's commitment to service can leave a lasting impact on a state, a community and
        future generations.
      </p>
    `,
  },
  /* ******************** HOF INDUCTEES ******************** */
  // Kelsey Chambers
  {
    id: "kelseyChambers",
    section: "hof",
    image: "assets/media/pages/alumni/distinguished-alumni/2026/hall-of-fame/kelsey-chambers.webp",
    name: "Kelsey Chambers",
    bio: html`
      <p>
        <strong>Kelsey Chambers </strong>graduated from Northern State University with a bachelor of
        science in special education in 2016, following a 4-year career on the volleyball team. She
        tallied 1,547 kills, 1,054 digs, 176 blocks, and 56 aces in her career, hitting .294.
      </p>

      <p>
        She is the school record holder with 1,547 career kills and 3,669 career attacks, and ranks
        top-5 in the record book in single match kills, single season kills, and career attack
        percentage. Chambers was the first AVCA All-American in program history following the 2013
        campaign, honored on the third team. In addition, she was a 4-time NSIC All-Conference
        selection with three first team nods, 2-time AVCA All-American, D2CCA All-American, a
        CoSIDA/Daktronics All-Region pick, and 2-time AVCA All-Region honoree. Chambers closed out
        her career as the 2016 Hildred Wolfe Award winner.
      </p>

      <p>
        Northern State advanced to the NCAA Central Region Tournament in 2013 and tallied a record
        of 85-33 during her tenure. The Wolves hit a national leading mark of .320 in 2015 on the
        back of Chambers who hit .346, and ranked third in the country in kills per set (14.00).
      </p>

      <p>
        Kelsey resides in Luxembourg, working as a teacher at the International School of
        Luxembourg. She played ten years of professional and semi-professional volleyball in Germany
        and Luxembourg with proWin Volleys TV Holz, RSR Walfer, Volley Bartreng, and the Escher
        Volleyball Club.
      </p>
    `,
  },
  // Conner Doherty
  {
    id: "robLewis",
    section: "hof",
    image: "assets/media/pages/alumni/distinguished-alumni/2026/hall-of-fame/rob-lewis.webp",
    name: "Rob Lewis",
    bio: html`
      <p>
        <strong>Rob Lewis </strong>graduated from Northern State University with a bachelor of
        science in education in 1995, following a 4-year career on the wrestling team. He tallied
        over 100 career victories at NSU, one of only 12 Wolves wrestlers to do so in the program’s
        history.
      </p>

      <p>
        Lewis is the career record holder with 80 wins by fall and recorded a pair of 30-win seasons
        in 1993 and 1994. He was a 3-time national qualifier in 1991, 1993, and 1994. He earned
        All-American accolades in 1993 as the runner-up and 1994, taking eighth. In addition, Lewis
        won the NSIC Championship in 1994.
      </p>

      <p>
        Rob resides in Redfield with his wife Dana and is the Superintendent for the Northwestern
        Area School District. In his career, Lewis was named the2004 11B Assistant Coach of the Year
        in football and the 2010 Region High School Principal of the Year. His 2003 team at Elk
        Point Jefferson won the South Dakota Class B Wrestling Championship. He is a member of the
        Redfield Volunteer Fire Department, the Redfield Soccer Association Board, and served 22
        years with the South Dakota National Guard. Rob and Dana have three children, Murphy, Jack,
        and Turner.
      </p>
    `,
  },
  // Arden Rapp
  {
    id: "arlinLikness",
    section: "hof",
    image: "assets/media/pages/alumni/distinguished-alumni/2026/hall-of-fame/arlin-likness.webp",
    name: "Arlin Likness",
    bio: html`
      <p>
        <strong>Arlin Likness</strong> graduated from Northern State University with a bachelor of
        science in social science and physical education with composite health in 1979 and is the
        2026 Kretchman Coaching Award recipient. Likness has taught and coached in the State of
        South Dakota for 39 years, serving the communities of Beresford, Hamlin, and Yankton in the
        sports of football, basketball, track and field, and baseball. He is the fifth winningest
        head football coach in South Dakota High School history.
      </p>

      <p>
        Likness holds a head football coaching record of 261-101 in 38 years of work, with seven
        South Dakota State Championships and three runner-up finish. In addition, he adds two state
        championships to his resume as an assistant. In total, Likness has coached in 13 state
        championship games, winning nine of them. As an assistant on staff with the boys and girls
        basketball programs at Hamlin and Yankton, Likness made 16 South Dakota State Tournament
        appearances, winning two championships. He was named the Assistant Coach of the Year in
        1992, 1993, and 2001. Finally, his track and field programs won three state championships.
      </p>

      <p>
        Likness’s honors include the 2013 Royal Order of the Gyps Alumni of the Year, 2015 SD Sports
        Writer’s Coach of the Year, SDHSCA Max Hawk Award, SDHSAA Distinguished Service Award, the
        Don Baker Award for Excellence in Coaching, seven South Dakota Football Region Coach of the
        Year Awards, five South Dakota Football Coach of the Year Awards, the ESD Conference Award
        of Merit, and a 2-time finalist for the National Power of Influence Award. He is a member of
        the South Dakota Football Coaches Association Hall of Fame (2010), South Dakota High School
        Coaches Hall of Fame (2017), Hamlin Hall of Fame (2024 & 2026), National High School
        Athletic Coaches Association Hall of Fame (2025), Yankton Athletic Hall of Fame (2026).
      </p>

      <p>
        Likness has served the South Dakota High School Coaches Association, National High School
        Coaches Association, South Dakota High School Football Coaches Association, South Dakota
        High School Football Advisory Board, South Dakota Coaches Foundation Board of Directors,
        Hayti Lutheran Congregation, Trinty Lutheran Congregation, F.C.A. Leadership Board of
        Directors, South Dakota Education Association, ST Dysmas of SD member of prison ministries,
        Worship Life Committee Choir, Yankton Booster Club, and Yankton ELCA.
      </p>

      <p>
        Arlin is married to his wife of 40-plus year, Kristine, and the pair have four children,
        Jordan, Kara, Kalli, and Jase, and one grandchild, Harper.
      </p>
    `,
  },
  // Todd Thorson
  {
    id: "mirandaObaniana",
    section: "hof",
    image: "assets/media/pages/alumni/distinguished-alumni/2026/hall-of-fame/miranda-obaniana.webp",
    name: "Miranda Obaniana",
    bio: html`
      <p>
        <strong>Miranda (Ristau) Obaniana </strong>graduated from Northern State University with a
        bachelor of science in honoribus in 2018, following a 4-year career on the women’s
        basketball team. She appeared in 105 games, making 63 starts for the Wolves in her career.
        Obaniana tallied 1,461 points, shooting 54.7% from the floor and 75.4% from the foul line,
        680 rebounds, 180 assists, and 172 blocks in her career.
      </p>

      <p>
        She holds school records in single game blocked shots (10), single season points scored
        (635), single season field goals made (254), and sits top-5 in the NSU record book in single
        game points, single game field goal attempts, single game free throw attempts, single game
        rebounds, single season points per game, single season field goal attempts, single season
        free throws made, single season free throw attempts, single season blocked shots, career
        field goal percentage, career field goals made, and career blocked shots. Obaniana ranks
        seventh all-time in career points with 1,461 and 16th in career rebounds with 680.
      </p>

      <p>
        Obaniana was a 2-time NSIC All-Conference selection, NSIC/Sanford Health Basketball
        Tournament All-Tournament team member, the 2018 NSIC Player of the Year, a D2CCA and WBCA
        All-American, NSIC Myles Brand Award winner, the 2018 CoSIDA Academic All-American® of the
        Year, the first in school history, and the 2018 Hildred Wolfe Award recipient. In addition,
        she earned the 2018 Butch Raymond Scholarship, the 2018 NCAA Postgraduate Scholarship, the
        NSIC Willis R. Kelly Award winner, and was the NSIC nominee for the 2018 NCAA Woman of the
        Year. The Wolves went 99-27 in her career, winning three NSIC North Division Championships,
        two NSIC Tournament titles, and the 2017-18 NSIC Championship. In addition, NSU qualified
        for the NCAA Central Region Tournament each season.
      </p>

      <p>
        Miranda and her husband Justin reside in Watertown, South Dakota. She works as a physical
        therapist at Sanford Canby Medical Center and is a volunteer assistant coach for the
        Florence-Henry girls basketball program.
      </p>
    `,
  },
  // 1992-93 Women's Track and Field Team
  {
    id: "drewReinot",
    section: "hof",
    image: "assets/media/pages/alumni/distinguished-alumni/2026/hall-of-fame/drew-reinot.webp",
    name: "Drew Reinot",
    bio: html`
      <p>
        <strong>Drew (Smith) Reinot </strong>graduated from Northern State University with a
        bachelor of science in psychology in 2016, following a 4-year career on the volleyball team.
        The Des Moines native tallied 4,774 assists, 909 digs, 173 blocks, 79 kills, and 73 aces in
        her career. She ranked second in the country in 2014, averaging 12.74 assists per set, and
        sat as the NCAA Division II national leader in assists per set in 2015 averaging 13.13.
      </p>

      <p>
        She broke the school record for career assists as a senior with 4,774 and currently sits
        second all-time. In addition, she sits top-5 in the record book in single match assists and
        single season assists, recording over 1,000 assists in each of her four seasons with a
        career high 1,326 in 2015. Northern State closed out the 2015 season as the NCAA National
        Statistical Leader in attack percentage, hitting .320, in large part to the efforts of
        Reinot. The Wolves went 85-33 in her career, reaching the NCAA Tournament in 2013.
      </p>

      <p>
        Reinot was a 4-time NSIC All-Conference performer, earning NSIC Player of the Year honors in
        2015. She was an AVCA All-Region honoree, an AVCA First Team All-American, and D2CCA
        All-American.
      </p>

      <p>
        Drew resides in Durham, North Carolina with her husband Hannes and their son Finn Arthur.
        She is a Perioperative Nurse at the Duke University Hospital.
      </p>
    `,
  },
  // 1992-93 Women's Track and Field Team
  {
    id: "davidSnelling",
    section: "hof",
    image: "assets/media/pages/alumni/distinguished-alumni/2026/hall-of-fame/david-snelling.webp",
    name: "David Snelling",
    bio: html`
      <p>
        <strong>David Snelling</strong> graduated from Northern State University with a bachelor of
        science in health and physical education in 2001, following a career with the football and
        track and field teams from 1997-2001.
      </p>

      <p>
        On the football field, Snelling was a 4-year starter for the Wolves. He led the team in the
        fall of 2000 with 66.0 tackles, including 3.0 tackles for a loss, as a cornerback where he
        was named the NSU Defensive Skill Player of the Year. In addition, he finished the year
        second on the team with two interceptions and nine pass break-ups and was named to the NSIC
        All-Conference First Team that season. Snelling was a member of the 1999 NSIC Championship
        team for the Wolves.
      </p>

      <p>
        On the track, Snelling was an 11-time NSIC All-Conference selection and a member of the 2001
        NSIC Indoor Championship team for NSU. He won NSIC Championships in the indoor 800m in 1999
        and outdoor 800m in 2000. He holds the school record in the 4x800m relay with Scott Gangle,
        Josh Lien, and Mike Larson with a time of 7:48.34, and was the previous school record holder
        in the indoor 400m, indoor 600m, indoor 800m, and indoor 4x400m. The 4x800m relay crew of
        Gangle, Lien, Larson, and Snelling also holds the Barnett Center record in the event.
      </p>

      <p>
        Snelling closed out his Northern State career as the 2001 Clark Swisher Award winner.
        Post-graduation, Snelling spent 15 years as a wildland fire fighter working for the State of
        South Dakota and the elite crew, Tatanka Hotshots.
      </p>
    `,
  },
];
